import PanelInvisible from "./PanelInvisible";

export default PanelInvisible;
